// extracted by mini-css-extract-plugin
export var actionText = "_qs-4";
export var container = "_qs-0";
export var leftSection = "_qs-1";
export var rightSection = "_qs-2";
export var settingsButton = "_qs-6";
export var settingsIcon = "_qs-7";
export var shortcut = "_qs-5";
export var shortcutGroup = "_qs-3";